var indentation_default = {
  "indentZero": "Bb686",
  "indentOne": "vMAxX",
  "indentTwo": "_2IfFF",
  "indentThree": "oVaOl",
  "indentFour": "fSpNQ",
  "indentFive": "mZF3s",
  "indentSix": "mGfmm"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
